import React from "react";

interface PasswordRecoveryEmailSentViewProps {
	email: string;
}

const PasswordRecoveryEmailSentView: React.FC<PasswordRecoveryEmailSentViewProps> = ({ email }) => {
	return (
		<div className="auth-view">
			<p className="auth-text-recovery">
				На email <span className="auth-verification-num">{email}</span> отправлено письмо со ссылкой. <br />
				Перейдите по ней для смены пароля. <br />
				Если его нет во входящих, проверьте папку «Спам».
			</p>
		</div>
	);
};

export default PasswordRecoveryEmailSentView;
